import { render, staticRenderFns } from "./TaskWorktable copy.vue?vue&type=template&id=a8898048&scoped=true"
import script from "./TaskWorktable copy.vue?vue&type=script&lang=js"
export * from "./TaskWorktable copy.vue?vue&type=script&lang=js"
import style0 from "./TaskWorktable copy.vue?vue&type=style&index=0&id=a8898048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8898048",
  null
  
)

export default component.exports